module.exports = __webpack_public_path__ + "static/media/022-syria.c4c8a93e.svg";